import { createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a3f2fba4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "h-100 container" }
const _hoisted_2 = {
  class: "modal fade",
  id: "confirmModal",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_3 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, null, -1 /* HOISTED */))
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-body" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode("シリアル番号を確認し、再度撮影するか"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("シリアル番号を正しく入力してください")
  ])
], -1 /* HOISTED */))
const _hoisted_8 = { class: "modal-footer" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "modal-body" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("シリアル番号：")
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))
const _hoisted_13 = { class: "modal-footer" }
const _hoisted_14 = {
  class: "modal fade",
  id: "duplicationModal",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_15 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_16 = { class: "modal-content" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, null, -1 /* HOISTED */))
const _hoisted_18 = { class: "modal-body" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "すでにこの車台番号はシステムに登録されていますが再度登録しなおしますか？", -1 /* HOISTED */))
const _hoisted_20 = { class: "modal-footer" }
const _hoisted_21 = {
  class: "modal fade",
  id: "inputErrorModal",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_22 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_23 = { class: "modal-content" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, null, -1 /* HOISTED */))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-body" }, [
  /*#__PURE__*/_createElementVNode("p", null, "正しい値を入力してください")
], -1 /* HOISTED */))
const _hoisted_26 = { class: "modal-footer" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, null, -1 /* HOISTED */))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-body" }, [
  /*#__PURE__*/_createElementVNode("p", null, "送信完了しました")
], -1 /* HOISTED */))
const _hoisted_29 = {
  key: 0,
  class: "alert alert-danger alert-dismissible fade show",
  role: "alert"
}
const _hoisted_30 = {
  key: 1,
  class: "alert alert-danger alert-dismissible fade show",
  role: "alert"
}
const _hoisted_31 = { key: 2 }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fs-5" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createTextVNode("車台番号、シリアル番号を"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("登録してください")
  ])
], -1 /* HOISTED */))
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = { key: 3 }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fs-5" }, [
  /*#__PURE__*/_createElementVNode("div", null, "シリアル番号を送信してください")
], -1 /* HOISTED */))
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = ["src"]
const _hoisted_38 = { key: 0 }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "btn btn-primary btn-sm",
  for: "selectFile"
}, "ファイルを選択", -1 /* HOISTED */))
const _hoisted_40 = { key: 1 }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "btn btn-secondary btn-sm",
  for: "selectFile"
}, "ファイルを選択", -1 /* HOISTED */))
const _hoisted_42 = { key: 2 }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "シリアル番号送信", -1 /* HOISTED */))
const _hoisted_44 = [
  _hoisted_43
]
const _hoisted_45 = { key: 3 }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "シリアル番号送信", -1 /* HOISTED */))
const _hoisted_47 = [
  _hoisted_46
]
const _hoisted_48 = { class: "rounded-3 mt-2" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-auto col-form-label" }, "車台番号", -1 /* HOISTED */))
const _hoisted_50 = {
  id: "vinNo",
  class: "col-auto d-flex justify-content-center"
}
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-auto col-form-label" }, "AGSシリアル番号（TR）", -1 /* HOISTED */))
const _hoisted_52 = { class: "col-auto d-flex justify-content-center" }
const _hoisted_53 = {
  key: 0,
  class: "col-auto col-form-label text-danger"
}
const _hoisted_54 = { key: 4 }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "車台番号、シリアル番号登録", -1 /* HOISTED */))
const _hoisted_56 = [
  _hoisted_55
]
const _hoisted_57 = { key: 5 }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "車台番号、シリアル番号登録", -1 /* HOISTED */))
const _hoisted_59 = [
  _hoisted_58
]
const _hoisted_60 = { class: "d-flex justify-content-end" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "戻る", -1 /* HOISTED */))
const _hoisted_62 = [
  _hoisted_61
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["Loading"], { isLoading: $setup.isLoading }, null, 8 /* PROPS */, ["isLoading"]),
    _createCommentVNode(" モーダル "),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          ($setup.serialNo === '')
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-secondary",
                    "data-bs-dismiss": "modal",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.postButtonFlag = true, $setup.selectFileFlag = false))
                  }, " 戻る ")
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("p", null, [
                    _hoisted_11,
                    _hoisted_12,
                    _createTextVNode(_toDisplayString($setup.serialNo), 1 /* TEXT */)
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-secondary",
                    "data-bs-dismiss": "modal",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.inputFix()))
                  }, " NO "),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-primary",
                    "data-bs-dismiss": "modal",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.postButtonFlag = false, $setup.selectFileFlag = false))
                  }, " YES ")
                ])
              ]))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _createElementVNode("p", null, "前回登録されたシリアル番号：" + _toDisplayString($setup.beforeSerialNo), 1 /* TEXT */)
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary",
              "data-bs-dismiss": "modal",
              onClick: _cache[3] || (_cache[3] = ($event: any) => {$setup.postButtonFlag = true, $setup.selectFileFlag = false;})
            }, " NO "),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              "data-bs-dismiss": "modal",
              onClick: $setup.postTieData
            }, " YES ")
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_21, [
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("div", _hoisted_23, [
          _hoisted_24,
          _hoisted_25,
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              "data-bs-dismiss": "modal",
              onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.inputFix()))
            }, " YES ")
          ])
        ])
      ])
    ]),
    _createElementVNode("div", {
      class: "modal fade",
      id: "completeModal",
      "data-bs-backdrop": "static",
      "data-bs-keyboard": "false",
      tabindex: "-1",
      "aria-hidden": "true"
    }, [
      _createElementVNode("div", { class: "modal-dialog modal-dialog-centered" }, [
        _createElementVNode("div", { class: "modal-content" }, [
          _hoisted_27,
          _hoisted_28,
          _createElementVNode("div", { class: "modal-footer" }, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              "data-bs-dismiss": "modal",
              onClick: $setup.toDisplayWorkPattern
            }, " YES ")
          ])
        ])
      ])
    ]),
    ($setup.ocrError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_29, " ファイルを選択してください "))
      : _createCommentVNode("v-if", true),
    ($setup.postTieDataValidationError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_30, " 登録に失敗しました。 "))
      : _createCommentVNode("v-if", true),
    (!$setup.postButtonFlag)
      ? (_openBlock(), _createElementBlock("div", _hoisted_31, _hoisted_33))
      : (_openBlock(), _createElementBlock("div", _hoisted_34, _hoisted_36)),
    _createElementVNode("img", {
      class: "image-area mb-1 mt-1",
      src: $setup.url
    }, null, 8 /* PROPS */, _hoisted_37),
    _createElementVNode("form", null, [
      (!$setup.selectFileFlag && $setup.postButtonFlag)
        ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
            _hoisted_39,
            _createElementVNode("label", null, " " + _toDisplayString($setup.filename), 1 /* TEXT */),
            _createElementVNode("input", {
              id: "selectFile",
              type: "file",
              onChange: $setup.selectedFile
            }, null, 32 /* HYDRATE_EVENTS */)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_40, [
            _hoisted_41,
            _createElementVNode("label", null, " " + _toDisplayString($setup.filename), 1 /* TEXT */),
            _createElementVNode("input", {
              id: "selectFile",
              type: "file",
              onChange: $setup.selectedFile
            }, null, 32 /* HYDRATE_EVENTS */)
          ])),
      ($setup.selectFileFlag)
        ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary mt-2",
              onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.submitPicture()))
            }, _hoisted_44)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_45, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary mt-2",
              onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.submitPicture()))
            }, _hoisted_47)
          ]))
    ]),
    _createElementVNode("div", _hoisted_48, [
      _hoisted_49,
      _createElementVNode("div", _hoisted_50, _toDisplayString($setup.vinNo), 1 /* TEXT */),
      _hoisted_51,
      _createElementVNode("div", _hoisted_52, [
        _withDirectives(_createElementVNode("input", {
          id: "serialNo",
          type: "text",
          class: "form-control w-75 text-center",
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.serialNo) = $event)),
          onInput: $setup.validateSerialNo,
          maxlength: "11"
        }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
          [
            _vModelText,
            $setup.serialNo,
            void 0,
            { trim: true }
          ]
        ])
      ]),
      _createElementVNode("div", null, [
        ($setup.failureText)
          ? (_openBlock(), _createElementBlock("label", _hoisted_53, "※シリアル番号（TR）を正しく入力してください"))
          : _createCommentVNode("v-if", true)
      ])
    ]),
    ($setup.serialNo.length === 11 && !$setup.postButtonFlag)
      ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary mt-2",
            onClick: _cache[8] || (_cache[8] = ($event: any) => ($setup.submitTieData()))
          }, _hoisted_56)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_57, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-secondary mt-2",
            onClick: _cache[9] || (_cache[9] = ($event: any) => ($setup.submitTieData()))
          }, _hoisted_59)
        ])),
    _createElementVNode("div", _hoisted_60, [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-secondary mt-2",
        onClick: _cache[10] || (_cache[10] = ($event: any) => ($setup.returnInitialPage()))
      }, _hoisted_62)
    ])
  ]))
}